import React, { useEffect } from 'react';
import { SimulationCard } from './SimulationCard';
import { useAuthStore } from '../../lib/store-auth';
import { useSimulationStore } from '../../lib/store-simulations';
import { Simulation } from '../../lib/supabase';

interface SimulationGridProps {
    onStartSimulation: (sim: Simulation) => void;
    onOpenSettings?: () => void;
}

export const SimulationGrid: React.FC<SimulationGridProps> = ({ onStartSimulation, onOpenSettings }) => {
    const { user } = useAuthStore();
    const { simulations, isLoading, fetchUserSimulations } = useSimulationStore();

    useEffect(() => {
        // Yeni mimari: user.institution_id kullan
        if (user?.institution_id) {
            fetchUserSimulations(user.institution_id);
        }
    }, [user, fetchUserSimulations]);

    // const [selectedSimulation, setSelectedSimulation] = React.useState<Simulation | null>(null);
    // const [showInstructionModal, setShowInstructionModal] = React.useState(false);

    /*
    const handleSimulationClick = (sim: Simulation) => {
        if (sim.config?.userInstruction && sim.config.userInstruction.trim() !== '') {
            setSelectedSimulation(sim);
            setShowInstructionModal(true);
        } else {
            onStartSimulation(sim);
        }
    };

    const handleConfirmStart = () => {
        if (selectedSimulation) {
            onStartSimulation(selectedSimulation);
            setShowInstructionModal(false);
            setSelectedSimulation(null);
        }
    };
    */

    if (isLoading) {
        return <div className="loading-spinner">Simülasyonlar yükleniyor...</div>;
    }

    if (simulations.length === 0) {
        return <div className="empty-state">Bu kurum için aktif simülasyon bulunamadı.</div>;
    }

    return (
        <div className="simulation-grid">
            {simulations.map((sim, index) => (
                <SimulationCard
                    key={sim.id}
                    index={index}
                    simulation={sim}
                    onStart={onStartSimulation}
                    showSettings={false} // Personel için ayarlar kapalı
                />
            ))}
        </div>
    );
};
